import { LineComponent } from './Line';
import { DougnutComponent } from './Doughnut';
import { ChartTypes } from './types';

export const CHART_TYPE_INFO = {
    [ChartTypes.LINE]: LineComponent,
    [ChartTypes.DOUGHNUT]: DougnutComponent,
} as const;